// fr/messages.js
const messagesFr = {
  about: 'À propos',
  acceptanceCriteria: 'Critères d\'acceptation',
  accomplishments: 'Réalisations',
  actions: 'Actions',
  activatePod: 'Activer le Pod',
  activePods: 'Pods actifs',
  activity: 'Activité',
  add: 'Ajouter',
  category:"Catégorie",
comments:"Commentaires",
 talentexplorer: "Explorateur de Talents",
 interviewrequests:"Demandes d'Entretien",
  createHub:	"Créer un Centre",
  createSolution: "Créer une Solution",
  addBlocker: 'Ajouter des Informations de Blocage',
  addingCandidateWait: 'Ajout du candidat en cours...',
  addPortfolio: 'Ajouter un portfolio',
  addStakeholder: 'Ajouter un intervenant',
  addVideoUpdate: 'Ajouter une Mise à Jour Vidéo',
  all: 'Tous',
  allReporters: 'Tous les reporters',
  allRepoCheckins: 'Toutes les validations de dépôt',
  approve: 'Approuver',
  findAgents:"Trouver des agents",
  approved: 'Approuvé',
  approvalRequests: 'Demandes d\'approbation',
  approvedPRCount: 'Nombre de PR approuvés',
  applyFilters: 'Appliquer les filtres',
  assignedItems: 'Éléments attribués',
  availability: 'Disponibilité',
  availableDate: 'Date de disponibilité',
  backToPods: 'Retour à Mes Pods',
  basicInformation: 'Informations de base',
  blocker: 'Obstacle',
  blockerDetails: 'Détails du Blocage',
  blockers: 'Obstacles',
  board: 'Tableau',
  browseTalent: 'Parcourir les talents',
  bugs: 'Bugs',
  calendlyUrl: 'URL Calendly',
  cancel: 'Annuler',
  candidate: 'Candidat',
  candidates: 'Candidats',
  categories: 'Catégories',
  certifications: 'Certifications',
  certificationUrl: 'URL de certification',
  checkBoxBlocker: 'Cochez cette case s\'il s\'agit d\'un bloqueur',
  ciCdPipeline: 'Pipeline CI/CD',
  clear: 'Effacer',
  clickHereUploadVideoClip: 'Cliquez ici pour télécharger un extrait vidéo !',
  client: 'Client',
  cloudCost: 'Coût Cloud',
  code: 'Lignes de Code',
  codeSmells: 'Code Smells',
  commentHere: 'commentaire ici...',
  companyName: 'Nom de l\'entreprise',
  copied: 'Copié !',
  copyright: 'Copyright © 2025-présent Brilli Global, Inc. Tous droits réservés.',
  copyToClipboard: 'Copier dans le presse-papiers',
  cost: 'Coût',
  costDetails: 'Détails du coût',
  country: 'Pays',
  create: 'Créer',
  createArt: 'Créer de l\'ART',
  createGig: 'Créer un projet',
  createPod: 'Créer un POD',
  createProfile: 'Créer un profil',
  createProfileOpportunity: 'Créez votre profil dans notre base de talents pour être inclus dans diverses opportunités de travail à distance.',
  createTask: 'Créer une tâche',
  createYourOwnPod: 'Créez votre propre Pod et parcourez les projets',
  creatingProfile: 'Création de profil',
  currency: 'Devise',
  currentlyAvailable: 'Actuellement disponible',
  currentWeek: 'Semaine en cours',
  dashboard: 'Tableau de bord',
  date: 'Date',
  dateRangeFilter: 'Filtre de plage de dates',
  deactivatePod: 'Désactiver le Pod',
  deactivateToUpdate: 'Désactivez le pod pour le mettre à jour !',
  defects: 'Défauts',
  delete: 'Supprimer',
  deletePod: 'Supprimer le Pod',
  description: 'Description',
  detailsForGitHubRepo: 'Détails du dépôt GitHub',
  done: 'Terminé',
  Done: 'Terminé',
  doraMetrics: 'Métriques Dora',
  dueDate: 'Date limite',
  duplicatedLinesDensity: 'Densité des lignes dupliquées',
  edit: 'Modifier',
  editPod: 'Modifiez votre pod et parcourez les projets',
  education: 'Éducation',
  educationAndCertifications: 'Éducation et Certifications',
  email: 'E-mail',
  endDate: 'Date de fin',
  enterEmailToInvite: 'Entrez une adresse e-mail pour inviter',
  enterPodMission: 'Entrer la mission du Pod',
  enterPodName: 'Entrer le nom du Pod',
  enterStoryDescription: 'Entrer une description de l\'histoire',
  executionDate: 'Date d\'exécution',
  executionID: 'ID d\'exécution',
  externalPod: 'Pod externe',
  fileNameNoSpaces: 'Le nom du fichier ne doit pas inclure d\'espaces entre tous les éléments ou caractères',
  fileUpload: 'Téléchargement de fichier',
  findBestFreelancers: 'Trouvez les meilleurs freelancers ou pods de talents pour obtenir la livraison de vos projets plus rapidement !',
  findBestPod: 'Trouvez des groupes correspondant à votre expérience/ensemble de compétences',
  findPods: 'Trouver des Pods',
  findTalent: 'Trouver du talent',
  findYourBestTalentPod: 'Trouvez votre meilleur POD de talent',
  firstName: 'Prénom',
  focus: 'Focus',
  getStarted: 'Commencer',
  gitHubRepo: 'Dépôt GitHub',
  gitHubUsername: 'Nom d\'utilisateur GitHub',
  github: 'Github',
  githubSummary: 'Résumé GitHub',
  githubUrl: 'URL Github',
  githubUser: 'Utilisateur GitHub',
  giveRating: 'Donner une note',
  globalWorkPlatform: 'Plateforme de travail mondiale',
  home: 'Accueil',
  hoursPerWeek: 'Heures par semaine',
  inactivePod: 'Pod Inactif',
  individual: 'Individuel',
  industry: 'Industrie',
  inProgress: 'En cours',
  institute: 'Institut',
  internalPod: 'Pod interne',
  invite: 'Inviter',
  invoices: 'Factures',
  issueKey: 'Clé du problème',
  issueStatus: 'État du problème',
  issueSummary: 'Résumé du problème',
  jiraIssue: 'Problème Jira',
  jiraIssues: 'Problèmes Jira',
  jiraItem: 'Élément Jira',
  jiraTimeDetails: 'Journal du Temps',
  jiraUsername: 'Nom d\'utilisateur Jira',
  joinPod: 'Rejoindre le Pod',
  keepDoing: 'Continuer à faire',
  keyword: 'Mot-clé',
  languageSpoken: 'Langue parlée',
  lastName: 'Nom de famille',
  latestSprintVelocity: 'Dernière vélocité du sprint',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'URL LinkedIn',
  linesOfCodeByDay: 'Lignes de code par jour',
  listOfTalents: 'Liste des talents',
  loading: 'Chargement',
  loadingAcceptanceCriteria: 'Chargement des critères d\'acceptation',
  loadingStoryDescription: 'Chargement de la description de l\'histoire',
  loadingTestCases: 'Chargement des cas de test',
  logOut: 'Se déconnecter',
  login: 'Connexion',
  manage: 'Gérer',
  manageActivities: 'Gérez vos activités et mises à jour quotidiennes du Pod',
  manageProfile: 'Gérer le profil',
  manageProfileHere: 'Gérez votre profil ici',
  managePod: 'Gérer le Pod',
  managePods: 'Gérez tous vos pods et leurs activités',
  markComplete: 'Marquer comme complet',
  middleName: 'Deuxième prénom',
  myPods: 'Mes Pods',
  myTasks: 'Mes tâches',
  name: 'Nom',
  ncloc: 'Ncloc',
  newActivityUpdate: 'Nouvelle Mise à Jour d\'Activité',
  next: 'Suivant',
  noArtOptionsAvailable: 'Aucune option ART disponible',
  noBlockers: 'Il n\'y a pas de blocage',
  noCandidates: 'Aucun candidat ajouté',
  noCandidatesAddedToPod: 'Aucun candidat ajouté au Pod !',
  noCandidateReviews: 'Il n\'y a pas d\'avis de candidat.',
  noData: 'Aucune donnée',
  noDataAvailable: 'Aucune donnée disponible',
  noExperience: 'Aucune expérience',
  noMatchingPods: 'Aucun pod correspondant disponible',
  noNotifications: 'Il n\'y a pas de notifications',
  noPodActivity: 'Vous n\'avez aucune activité de POD',
  noPods: 'Vous n\'avez aucun Pod',
  noPodTasks: 'Vous n\'avez aucune tâche de Pod',
  noReviews: 'Il n\'y a pas de critiques',
  noStakeholders: 'Il n\'y a pas d\'intervenants pour ce Pod',
  noSubscription: 'Vous n\'avez aucun plan d\'abonnement',
  noVideoAvailable: 'Aucune vidéo disponible',
  notifications: 'Notifications',
  notificationRecipient: 'Destinataire de la notification',
  otherInformation: 'Autres informations',
  pending: 'En attente',
  pendingPods: 'Pods en attente',
  phoneNumber: 'Numéro de téléphone',
  pipelineExecutionDetails: 'Détails de l\'exécution du pipeline',
  pipelineName: 'Nom du pipeline',
  pipelineVersion: 'Version du pipeline',
  pleaseEnterStoryDescription: 'Veuillez saisir une description d\'histoire et cliquer sur soumettre',
  pod: 'Pod',
  podActivities: 'Activités du Pod',
  podActivity: 'Activité du Pod',
  podAnalytics: 'Analytiques de POD',
  podAssist: 'Assistance POD',
  podAutomation: 'Automation de POD',
  podBoard: 'Tableau du Pod',
  podCategories: 'Catégories de Pod',
  podDescription: 'Description du Pod',
  podExperience: 'Expérience de Pod',
  podFeedback: 'Feedback de Pod',
  podMetrics: 'Métriques de Pod',
  podName: 'Nom du Pod',
  podQuery: 'Requête de POD',
  podrate: 'Taux de Reproduction',
  podRequests: 'DEMANDES DE POD',
  podRetro: 'Rétrospective du Pod',
  podSize: 'Taille du Pod',
  podTask: 'Tâche du Pod',
  podTasks: 'Tâches du Pod',
  podTaskDescription: 'Description de la tâche de Pod',
  podTaskDueDate: 'Date d\'échéance de la tâche de Pod',
  podTaskName: 'Nom de la tâche de Pod',
  podTaskOwner: 'Propriétaire de la tâche de Pod',
  podTaskStatus: 'Statut de la tâche de Pod',
  podTechStack: 'Tech Stack du Pod',
  PodTeamMember: 'un membre de l\'équipe du POD',
  podType: 'Type de Pod',
  portfolio: 'Portfolio',
  portfolioUrl: 'URL du portfolio',
  post: 'Publier',
  postActivity: 'Publier une Activité',
  postPodActivity: 'Publier l\'activité du Pod',
  postRequirement: 'Publier une exigence',
  posting: 'Publication en cours...',
  postedDate: 'Date de publication',
  postedRequirements: 'Vos exigences Pod publiées',
  positionName: 'Nom du poste',
  prCount: 'Nombre de PR',
  preferredWorkHours: 'Heures de travail préférées',
  preferredWorkHoursMonthly: 'Heures de travail préférées /mois',
  prev: 'Précédent',
  previousPods: 'Pods précédents',
  previousWeek: 'Semaine précédente',
  primarySkill: 'Compétence principale',
  privacyPolicy: 'Politique de confidentialité',
  privatePods: 'Pods privés',
  prSummary: 'Résumé des PR',
  projectKey: 'Clé du projet',
  profileLink: 'Lien du Profil',
  profileVisibility: 'Visibilité du Profil',
  public: 'Public',
  qualification: 'Qualification',
  ratePerHour: 'Taux /heure',
  ratePerMonth: 'Taux /mois',
  recentSearches: 'Recherches récentes',
  region: 'Région',
  Register: 'S\'inscrire',
  resetPassword: 'Réinitialiser le mot de passe',
  restricted: 'Restreint',
  retro: 'Rétro',
  reviewAndRating: 'Évaluation & Note',
  revisionSummary: 'Résumé de la révision',
  revisionURL: 'URL de la révision',
  resume: 'Curriculum vitae',
  resumeLink: 'Voir le CV',
  rowsPerPage: 'Lignes par page',
  save: 'Enregistrer',
  search: 'Rechercher',
  searchProjects: 'Rechercher des projets',
  secondarySkill: 'Compétence secondaire',
  select: 'Sélectionner',
  selectArtName: 'Sélectionnez le nom de l\'ART',
  selectAUser: 'Sélectionner un utilisateur',
  selectFilter: 'Sélectionner un filtre',
  selectItemsPerPage: 'Sélectionner les éléments par page',
  selectJiraIssues: 'Sélectionner les Problèmes Jira',
  selectPod: 'Sélectionnez un Pod',
  selectPodTeamMember: 'Sélectionnez un membre de l\'équipe du POD',
  selectPods: 'Sélectionner des PODs',
  services: 'Services',
  setting: 'Paramètre',
  shareableLink: 'Lien Partageable',
  signUpToGetStarted: '"Inscrivez-vous" ci-dessous pour commencer!',
  skills: 'Compétences',
  skillsAndExpertise: 'Compétences et Expertise',
  sonarqubeprojectkey: 'Clé du Projet Sonarqube',
  sonarqubeStats: 'Statistiques Sonarqube',
  specialization: 'Spécialisation',
  sprintVelocity: 'Vélocité de sprint',
  sprint: 'Sprint',
  spotsLeft: 'Places disponibles',
  startDate: 'Date de début',
  startDoing: 'Commencer à faire',
  status: 'Statut',
  stopDoing: 'Arrêter de faire',
  storyDescription: 'Description de l\'histoire',
  stories: 'Histoires',
  submit: 'Soumettre',
  submittedDate: 'Date de soumission',
  submittedPRCount: 'Nombre de PR soumis',
  subscription: 'Abonnement',
  talentApprovalRequests: 'Demandes d\'approbation de talent',
  talentCode: 'Code Talent',
  talent: 'Talent',
  taskForm: 'Formulaire de tâche',
  taskManager: 'Gestionnaire de tâches',
  taskName: 'Nom de la tâche',
  tasks: 'Tâches',
  teamMember: 'Membre de l\'équipe',
  techStack: 'TechStack',
  termsOfService: 'Conditions d\'utilisation',
  testCases: 'Cas de test',
  time: 'Temps',
  timeLog: 'Journal du temps',
  timeSubmit: 'Soumettre le Temps',
  timeZone: 'Fuseau horaire',
  toDo: 'À faire',
  todaysFocus: 'Focus du Jour',
  totalLinesChangedLastWeek: 'Total des lignes modifiées la semaine dernière',
  totalLinesChangedThisWeek: 'Total des lignes modifiées cette semaine',
  totalPRCount: 'Nombre total de PR',
  university: 'Université',
  update: 'Mettre à jour',
  updateProfileHere: 'Mettez à jour votre profil ici',
  updatingVisibility: 'Mise à jour de la visibilité...',
  upload: 'Télécharger',
  userStory: 'Récit utilisateur',
  validFrom: 'Valide à partir de',
  validTill: 'Valide jusqu\'à',
  videoUrl: 'URL de la vidéo',
  view: 'Voir',
  viewActivities: 'Voir les Activités',
  viewActivity: 'Voir l\'activité',
  viewDetails: 'Voir les détails',
  viewPodActivities: 'Voir les activités du Pod',
  viewPodDetails: 'Voir les détails du Pod',
  viewProfile: 'Voir le profil',
  viewTasks: 'Voir les tâches',
  viewTimeEntries: 'Voir les entrées de temps',
  viewVideo: 'Voir la vidéo',
  visitFindTalent: 'Veuillez visiter la page \'Trouver des talents\' et ajouter des individus talentueux à votre pod.',
  vulnerabilities: 'Vulnérabilités',
  welcome: 'Bienvenue sur Artemy.ai!',
  workExperience: 'Expérience professionnelle',
  yourPod: 'Votre Pod',
  yourPods: 'Vos Pods',
  podTime: "Temps du POD",
  podsync:"Synchronisation POD",
  podVelocity: "Vélocité du POD",
   podBlockers: "Bloqueurs du POD",
  yourPostedPodActivity: 'Votre activité de Pod publiée',
 
  findTickets: 'Trouver des Tickets',
  epics: 'Epiques',
  podTasks: 'Tâches du Pod',
  date: 'Date',
  talent: 'Talent',
  focus: 'Focus',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  status: 'Statut',
  allStatus: 'Tous les Statuts',
  blocked: 'Bloqué',
  onTrack: 'Sur la Bonne Voie',
  activityDetails: 'Détails de l\'Activité',
  jiraIssues: 'Problèmes Jira',
  todaysFocus: 'Focus du Jour',
  accomplishments: 'Réalisations',
  blockers: 'Blocages',
  videoUpdate: 'Mise à Jour Vidéo',
  comments: 'Commentaires',
  addBlockerInformation: 'Ajouter des Informations de Blocage',
  blockerDetails: 'Détails du Blocage',
  cancel: 'Annuler',
  saveChanges: 'Enregistrer les Modifications',
  selectJiraIssues: 'Sélectionner les Problèmes Jira',
  design: 'Conception',
  development: 'Développement',
  testing: 'Test',
  bugFix: 'Correction de Bug',
  documentation: 'Documentation',
  myPods: 'Mes Pods',
  postRetro: 'Publier Rétrospective',
  newRetro: 'Nouvelle Rétrospective',
  startDoing: 'Commencer à Faire',
  stopDoing: 'Arrêter de Faire',
  keepDoing: 'Continuer à Faire',
  viewRetros: 'Voir les Rétrospectives',
  podRetroFeedback: 'Feedback de Rétrospective du Pod',
  selectSprint: 'Sélectionner le Sprint',
  thisTaskIsBlocker: 'Cette tâche est un bloqueur',
  category: 'Catégorie',
  taskCreatedSuccessfully: 'Tâche créée avec succès!',
  taskManagement: 'Gestion des Tâches',
  searchJiraIssues: 'Rechercher des problèmes JIRA...',
  creatingTask: 'Création de Tâche...',
  createTask: 'Créer une Tâche',
  description: 'Description',
  dueDate: 'Date d\'échéance',
  commentsHistory: 'Historique des Commentaires',
  noCommentsYet: 'Pas encore de commentaires',
  writeAComment: 'Écrire un commentaire...',
  all: 'Tous',
  blockerStatus: 'Statut de Blocage',
  blockedTasks: 'Tâches Bloquées',
  unblockedTasks: 'Tâches Débloquées',
  clearDateRange: 'Effacer la Plage de Dates',
  selectDateRange: 'Sélectionner une Plage de Dates',
  showAllTime: 'Afficher Toutes les Périodes',
  noTasksFound: 'Aucune tâche trouvée',
  noLinkedIssues: 'Aucun problème lié',
  timeSheet: 'Feuille de Temps',
  podTimeSheet: 'Feuille de Temps du Pod',
  userStory: 'Histoire Utilisateur',
  hours: 'Heures',
  minutes: 'Minutes',
  actions: 'Actions',
  submitTimeEntries: 'Soumettre les Entrées de Temps',
  selectCategory: 'Sélectionner une Catégorie',
  selectStory: 'Sélectionner une Histoire',
  addRow: 'Ajouter une Ligne',
  podSelection: 'Sélection du Pod',
  selectPodToView: 'Sélectionnez un pod pour voir le sprint et les filtres de Talent',
  toDo: 'À Faire',
  podAssist: 'Assistance POD',
  inProgress: 'En Cours',
  done: 'Terminé',
  selectPodsRequired: 'Sélectionner des Pods (Requis)',
  enterStoryDescription: 'Entrer une Description de l\'Histoire',
  podSyncSummaries: 'Résumés de Synchronisation POD',
  enterMeetingUrl: 'Entrer l\'URL de la réunion...',
  searchInSummaries: 'Rechercher dans les résumés...',
  dateAndTime: 'Date et Heure',
  quickTimeRange: 'Plage de Temps Rapide',

  podAutomation: 'Automatisation de Pod',
  uploading: 'Téléchargement en cours...',
  uploadFile: 'Télécharger le Fichier',
  send: 'Envoyer',
  submitting: 'Soumission en cours...',
  enterYourQuestionHere: 'Entrez votre question ici',
  submitTheResults: 'Soumettre les résultats',
  export: 'Exporter',
  podInsights: 'Aperçu des Pods',
  askQuestionsAboutYourPod: 'Posez des questions sur les activités de votre pod, les membres de l\'équipe et plus encore',
  welcomeToPodInsights: 'Bienvenue dans Aperçu des Pods!',
  startByAskingQuestionsLike: 'Commencez par poser des questions comme',
  showAllPodActivitiesThatHadBlockers: 'Afficher toutes les activités du pod qui avaient des blocages',
  listAllCandidatesAndTheirPods: 'Lister tous les candidats et leurs pods',
  showStakeholdersFromIndia: 'Afficher les parties prenantes de l\'Inde',
  askAnythingAboutYourPods: 'Demandez n\'importe quoi sur vos pods, membres de l\'équipe, activités...',
  sending: 'Envoi en cours...',
  analyzingYourQuestion: 'Analyse de votre question...',
  pipelineCICD: 'Pipeline CI/CD',
  tickets: 'Tickets',
  metricName: 'Nom de la Métrique',
  metricValue: 'Valeur de la Métrique',
  commentsHistory: 'Historique des Commentaires',
  noCommentsYet: 'Pas encore de commentaires',
  writeAComment: 'Écrire un commentaire...',
  solutionManagement: 'Gestion des Solutions',
  searchSolutions: 'Rechercher des Solutions...',
  refresh: 'Actualiser',
  createNewSolution: 'Créer une Nouvelle Solution',
  solutionName: 'Nom de la Solution',
  solutionDescription: 'Description de la Solution',
  updateSolution: 'Mettre à jour la Solution',
  createSolution: 'Créer une Solution',
  confirmSolutionDeletion: 'Êtes-vous sûr de vouloir supprimer la Solution',
  artManagement: 'Gestion ART',
  podManagement: 'Gestion des Pods',
  searchPods: 'Rechercher des pods...',
  viewPod: 'voirPod',
  searchARTs: 'Rechercher des ARTs...',
  noARTsFound: 'Aucun ART trouvé. Créez votre premier ART en cliquant sur le bouton "Créer un nouvel ART".',
  createNewART: 'Créer un Nouvel ART',
  selectGig: 'Sélectionner un Projet',
  artName: 'Nom ART',
  artDescription: 'Description ART',
  createART: 'Créer ART',
  confirmDeletion: 'Confirmer la Suppression',
  confirmARTDeletion: 'Êtes-vous sûr de vouloir supprimer l\'ART',
  primaryLanguage: 'Langue Principale',
  selectSkills: 'Sélectionner des Compétences',
  timeZone: 'Fuseau Horaire',
  updateART: 'Mettre à jour ART',
  somethingWentWrong: 'Quelque chose s\'est mal passé',
  reloadPage: 'Recharger la Page',
  privatePods: 'Pods Privés',
  activePods: 'Pods Actifs',
  completedPods: 'Pods Terminés',
  pendingPods: 'Pods en Attente',
  loadingPods: 'Chargement des pods...',
  retry: 'Réessayer',
  noPodsFound: 'Aucun pod trouvé',
  createFirstPod: 'Créez votre premier pod pour commencer',
  previous: 'Précédent',
  showing: 'Affichage',
  size: 'Taille',
  teamSize: 'Taille de l\'Équipe',
  activeMembers: 'Membres Actifs',
  stakeholders: 'Parties Prenantes',
  podManagers: 'Gestionnaires de Pod',
  addManager: 'Ajouter un Gestionnaire',
  podManager: 'Gestionnaire de Pod',
  noManagersAssignedYet: 'Aucun gestionnaire assigné pour le moment',
  addManagersToHelpOversee: 'Ajoutez des gestionnaires pour aider à superviser ce pod',
  noStakeholdersYet: 'Aucune partie prenante pour le moment',
  settings: 'Paramètres',
  deletePod: 'Supprimer le Pod',
  addPodManager: 'Ajouter un Gestionnaire de Pod',
  selectManagerToInvite: 'Sélectionnez un gestionnaire à inviter à ce pod:',
  noManagersAvailableToInvite: 'Aucun gestionnaire disponible à inviter.',
  selectAManager: 'Sélectionner un gestionnaire',
  selectedManager: 'Gestionnaire Sélectionné',
  inviteManager: 'Inviter un Gestionnaire',
  noTeamMembersYet: 'Aucun membre de l\'équipe pour le moment',
  startByInvitingMembers: 'Commencez par inviter des membres dans votre pod',
  inviteTeamMembers: 'Inviter des Membres de l\'Équipe',
  existingMembers: 'Membres Existants',
  inviteByEmail: 'Inviter par Email',
  searchByNameOrSkills: 'Rechercher par nom ou compétences...',
  optionalSelectUserToNotify: 'Optionnel: Sélectionnez un utilisateur à notifier via Slack',
  pleaseSelectPodToEnableFields: 'Veuillez sélectionner un Pod pour activer d\'autres champs',
  selectedCandidates: 'Candidats Sélectionnés',
  selectCandidatesToInvite: 'Sélectionnez des candidats à inviter à ce pod',
  availableCandidates: 'Candidats Disponibles',
  inviteNewMembersByEmail: 'Inviter de Nouveaux Membres par Email',
  emailAddresses: 'Adresses Email',
  enterEmailAddresses: 'Entrez des adresses email (séparées par des virgules)',
  hidePodTeamMembers: 'Masquer les membres de ce pod dans la section Trouver des Pods (Actuellement Visible)',
  technicalDetails: 'Détails Techniques',
  currentTeamSize: 'Taille actuelle de l\'équipe',
  communicationDetails: 'Détails de Communication',
  podReview: 'Évaluation du Pod',
  rating: 'Évaluation',
  writeReview: 'Écrire un Avis',
  shareYourExperience: 'Partagez votre expérience avec ce pod...',
  submitReview: 'Soumettre l\'Avis',
  viewPod: 'Voir le Pod',
  managePod: 'Gérer le Pod',
  editPod: 'Modifier le Pod',
  skillsAndExperience: 'Compétences et Expérience',
  reviews: 'Avis',
  documents: 'Documents',
  otherInfo: 'Autres Informations',
  noWorkExperienceDataAvailable: 'Aucune donnée d\'expérience professionnelle disponible',
  selectART: 'Sélectionner ART',
  selectAnART: 'Sélectionner un ART',
  jiraConfiguration: 'Configuration Jira',
  jiraProjectKey: 'Clé de Projet Jira',
  jiraURL: 'URL Jira',
  jiraAdminEmail: 'Email Admin Jira',
  jiraAdminAPIToken: 'Token API Admin Jira',
  jiraOpenStoryBugStatus: 'Statut Histoire/Bug Ouvert Jira',
  jiraClosedStoryBugStatus: 'Statut Histoire/Bug Fermé Jira',
  gitHubConfiguration: 'Configuration GitHub',
  gitHubUsername: 'Nom d\'utilisateur GitHub',
  gitHubAPIToken: 'Token API GitHub',
  gitHubRepositoryName: 'Nom du Dépôt GitHub',
  circleCIConfiguration: 'Configuration CircleCI',
  circleCIGitHubUsername: 'Nom d\'utilisateur GitHub CircleCI',
  circleCIGitHubRepository: 'Dépôt GitHub CircleCI',
  circleCIAPIToken: 'Token API CircleCI',
  sonarQubeConfiguration: 'Configuration SonarQube',
  sonarQubeCloudURL: 'URL SonarQube Cloud',
  sonarQubeAPIToken: 'Token API SonarQube',
  awsConfiguration: 'Configuration AWS',
  awsAccessKeyID: 'ID Clé d\'Accès AWS',
  awsSecretAccessKey: 'Clé Secrète d\'Accès AWS',
  awsRegion: 'Région AWS',
  bitBucketConfiguration: 'Configuration BitBucket',
  bitBucketUsername: 'Nom d\'utilisateur BitBucket',
  bitBucketAppPassword: 'Mot de passe App BitBucket',
  bitBucketWorkspace: 'Espace de Travail BitBucket',
  openAIConfiguration: 'Configuration OpenAI',
  openAIToken: 'Token OpenAI',
  storyPointsCalculation: 'Calcul des Points d\'Histoire',
  uploadStoryPointsCalculationFile: 'Télécharger le Fichier de Calcul des Points d\'Histoire',
  currentFile: 'Fichier actuel',
  notifications: 'Notifications',
  markAllAsRead: 'Tout marquer comme lu',
  tryAgain: 'Réessayer',
  noNotificationsToDisplay: 'Aucune notification à afficher',
  viewAllNotifications: 'Voir Toutes les Notifications',
  enterMultipleEmailsSeparatedByCommas: 'Entrez plusieurs emails séparés par des virgules',
  addEmailAddressesToInvite: 'Ajoutez des adresses email pour inviter de nouveaux membres',
  emailInvitationGuidelines: 'Instructions d\'Invitation par Email',
  inviteesWillReceiveInstructions: 'Les invités recevront des instructions pour rejoindre ce pod',
  theyWillNeedToCreateAccount: 'Ils devront créer un compte s\'ils n\'en ont pas déjà un',
  noCandidatesAvailable: 'Aucun candidat disponible',
  sendEmailInvites: 'Envoyer les Invitations par Email',
 
  processingDataAndGeneratingInsights: 'Traitement des données et génération d\'insights',
  retroHistory: 'Historique des Rétrospectives',
  filterByMember: 'Filtrer par Membre',
  podProductivity: 'Productivité du Pod',
  totalTasks: 'Tâches Totales',
  completed: 'Terminées',
  clearFilters: 'Effacer les Filtres',
  totalActivities: 'Activités Totales',
  pendingApproval: 'En Attente d\'Appro',
  sortBy: 'Trier Par',
  editSolution: 'Modifier la Solution',
  cannotDeleteAssociatedWithARTs: 'Impossible de supprimer - associé à des ARTs',
  editART: 'Modifier ART',
  createdDate: 'Date de Création',
  podDetails: 'Détails du Pod',
  currentARTProject: 'ART/Projet Actuel',
  artProject: 'ART/Projet',
  selectAvailability: 'Sélectionner la Disponibilité',
  selectSkill: 'Sélectionner une Compétence',
  selectTimezone: 'Sélectionner le Fuseau Horaire',
  selectLocation: 'Sélectionner le Lieu',
  selectBudget: 'Sélectionner le Budget',
  podMember: 'Membre du Pod',
  addToPod: 'Ajouter au Pod',
  talentDetails: 'Détails du Talent',
  reviewsFeedback: 'Avis et Commentaires',
  noEducationDataAvailable: 'Aucune donnée d\'éducation disponible',
  noCertificationDataAvailable: 'Aucune donnée de certification disponible',
  clientReview: 'Avis Client',
  noReviewsAvailableYet: 'Aucun avis disponible pour le moment',
  noClientReviews: 'Ce talent n\'a reçu aucun avis client jusqu\'à présent',
  resumeAvailable: 'CV Disponible',
  viewDownloadResume: 'Voir ou télécharger le CV du candidat',
  noResumeAvailable: 'Aucun CV Disponible',
  noResumeUploaded: 'Ce talent n\'a pas téléchargé de CV.',
  codingAssessment: 'Évaluation de Codage',
  assessmentAvailable: 'Évaluation Disponible',
  viewAssessmentResults: 'Voir les résultats de l\'évaluation de codage du candidat',
  noAssessmentAvailable: 'Aucune évaluation disponible',
  noAssessmentCompleted: 'Ce talent n\'a pas complété d\'évaluation de codage.',
  partnerCompanyDetails: 'Détails de l\'Entreprise Partenaire',
  companyIntroductionVideo: 'Vidéo de Présentation de l\'Entreprise',
  videoNotSupported: 'Votre navigateur ne supporte pas la balise vidéo.',
  location: 'Localisation',
  noPodsMatchingCriteria: 'Aucun pod trouvé correspondant à vos critères',
  hirePod: 'Engager le Pod',
  notificationHistory: 'Historique des Notifications',
  filter: 'Filtrer',
  allNotifications: 'Toutes les Notifications',
  markSelected: 'Marquer Sélectionnées',
  unread: 'Non Lus',
  noNotificationsFound: 'Aucune notification trouvée',
  searchNotifications: 'Rechercher des notifications...',
   subscriptionManagement: 'Gestion des Abonnements',
  choosePlanPrompt: 'Choisissez un plan qui correspond le mieux à vos besoins et évoluez au fur et à mesure de votre croissance',
  cancelSubscription: 'Annuler l\'Abonnement',
  choosePlan: 'Choisir un Plan',
  noPlansAvailable: 'Aucun Plan Disponible',
  noPlansHelpText: 'Veuillez revenir plus tard ou contacter le support pour obtenir de l\'aide.',
  currentPlanDetails: 'Détails du Plan Actuel',
  renewalDate: 'Date de Renouvellement',
  subscriptionId: 'ID d\'Abonnement',
  paymentMethod: 'Méthode de Paiement',
  cardHolder: 'Titulaire de la Carte',
  expires: 'Expire',
  brand: 'Marque',
  billingHistory: 'Historique de Facturation',
  noInvoiceHistory: 'Aucun historique de facture disponible',
  needHelp: 'Besoin d\'Aide ?',
  supportText: 'Si vous avez des questions sur nos plans d\'abonnement ou besoin d\'assistance, notre équipe de support est là pour vous aider.',
  contactSupport: 'Contacter le Support',
  completeSubscription: 'Complétez votre Abonnement',
  planDetails: 'Détails du Plan',
  planName: 'Nom du Plan',
  basePrice: 'Prix de Base',
  numberOfUsers: 'Nombre d\'Utilisateurs',
  billingCycle: 'Cycle de Facturation',
  orderSummary: 'Résumé de la Commande',
  annualDiscount: 'Remise Annuelle',
  billingPeriod: 'Période de Facturation',
  tax: 'Taxe',
  totalWithTax: 'Total avec Taxes',
  annually: 'annuellement',
  continue: 'Continuer',
  subscriptionSuccessful: 'Abonnement Réussi !',
  thankYouSubscribing: 'Merci de vous être abonné à',
  subscriptionActivated: 'Votre abonnement a été activé avec succès.',
  goToDashboard: 'Aller au Tableau de Bord',
  addPaymentMethod: 'Ajouter une Méthode de Paiement',
  cardNumber: 'Numéro de Carte',
  cardholderName: 'Nom du Titulaire',
  expiryMonth: 'Mois d\'Expiration',
  expiryYear: 'Année d\'Expiration',
  postalCode: 'Code Postal',
  addCard: 'Ajouter une Carte',
  paymentChoice: 'Utiliser une Carte Existante ou Ajouter une Nouvelle Carte',
  existingCardText: 'Vous avez déjà une carte existante se terminant par',
  useExistingCardPrompt: 'Souhaitez-vous l\'utiliser pour cet abonnement ?',
  useExistingCard: 'Utiliser la Carte Existante',
  addNewCard: 'Ajouter une Nouvelle Carte',
  processing: 'Traitement en cours...',
  subscriptionSuccessDetails: 'a réussi !',
  accessAllFeatures: 'Vous pouvez maintenant accéder à toutes les fonctionnalités incluses dans votre plan d\'abonnement.',
  editCardDetails: 'Modifier les Détails de la Carte',
  managerInvite: 'Invitation de Gestionnaire',
  talentInvite: 'Invitation de Talent',
  invitePodManagers: 'Entrez l\'E-Mail pour Inviter les Gestionnaires de Pod',
  enterEmail: 'Entrez l\'E-Mail',
  invite: 'Inviter',
  yourInvoices: 'Vos Factures',
  noInvoices: 'Vous n\'avez aucune facture.',
  amountDue: 'Montant Dû',
  getCountIsseswithNoCritria: 'Obtenir le nombre de problèmes sans critères d\'acceptation',
  amountPaid: 'Montant Payé',
  noActiveSubscription: 'Vous n\'avez pas de plan d\'abonnement actif. Veuillez cliquer sur le lien "S\'abonner" pour ajouter un abonnement.',
  noActiveSubscriptionStart: 'Vous n\'avez pas de plan d\'abonnement actif. Veuillez cliquer sur le',
  subscribe: 'S\'abonner',
  noActiveSubscriptionEnd: 'lien pour ajouter un abonnement.'};
export default messagesFr;
